import { useEffect } from "react";

// Copies each column header's text onto the matching cells of every
// <table data-stack>, as data-label, so mobileTables.css can show it beside
// the value once the row is stacked into a card (see that file). Tables render
// and re-render all over the app, so this watches the DOM once, here, instead
// of every table component labelling its own cells.
function labelStackedTables() {
  document.querySelectorAll("table[data-stack]").forEach((table) => {
    const headers = Array.from(table.querySelectorAll("thead th")).map((th) => th.textContent.trim());
    table.querySelectorAll("tbody tr").forEach((tr) => {
      Array.from(tr.children).forEach((cell, i) => {
        const label = headers[i] ?? "";
        if (cell.getAttribute("data-label") !== label) cell.setAttribute("data-label", label);
      });
    });
  });
}

export default function useStackedTableLabels() {
  useEffect(() => {
    let frame = null;
    const schedule = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = null;
        labelStackedTables();
      });
    };
    schedule();
    // childList only: setting data-label is an attribute change, so labelling
    // never re-triggers this observer.
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => {
      observer.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);
}
